import { render, staticRenderFns } from "./LimitsByBets.vue?vue&type=template&id=43b8f52a&"
import script from "./LimitsByBets.vue?vue&type=script&lang=js&"
export * from "./LimitsByBets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports